<template>
    <div>
        <div v-if="errors" v-for="error in errors">
            <div class="div" v-if="Array.isArray(error)">
                <div class="alert alert-danger" role="alert" v-for="er in error">{{ er }}</div>
            </div>
            <div class="alert alert-danger" role="alert" v-else>{{ error}}</div>

        </div>

        <b-form @submit="onSubmit">
            <b-form-group
                    id="input-name"
                    label="ФИО"
                    label-for="name"
                    description=""
            >
                <b-form-input
                        id="name"
                        v-model="item.name"
                        type="text"
                        placeholder="Name"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-phone"
                    label="Телефон"
                    label-for="phone"
                    description=""
            >
                <b-form-input
                        id="phone"
                        v-model="item.phone"
                        type="text"
                        placeholder="Phone"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-email"
                    label="E-mail"
                    label-for="email"
            >
                <b-form-input
                        id="email"
                        v-model="item.email"
                        type="email"
                        placeholder="Email"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-password"
                    label="Пароль"
                    label-for="password"
            >
                <b-form-input
                        id="password"
                        v-model="item.password"
                        type="password"
                        placeholder="Пароль"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-check-password"
                    label="Повторите пароль"
                    label-for="check-password"
            >
                <b-form-input
                        id="check-password"
                        v-model="item.password_confirmation"
                        type="password"
                        placeholder="Повторите пароль"
                ></b-form-input>
            </b-form-group>

            <div class="buttons">
                <b-button type="submit">Зарегистрировать</b-button>
            </div>
        </b-form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                item: {},
                errors: []
            }
        },

        mounted() {
            if (this.$route.params.id) {
                this.axios
                    .get(this.axios.defaults.baseURL + 'admin/managers/' + this.$route.params.id)
                    .then(response => {
                        this.item = response.data.manager
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }
        },

        methods: {
            checkForm:function(e) {
                e.preventDefault();
                this.errors = [];
                if(!this.item.name) this.errors.push("ФИО обязателен.");
                if(!this.item.email) this.errors.push("Email обязателен.");
                if(!this.item.phone) this.errors.push("Номер обязателен.");
                if (!this.item.password) this.errors.push("Пароль обязателен.");
                if (this.item.password && this.item.password.length <= 5) this.errors.push("Минимальная длина пароля 6 символов.");
                if (!/\d/.test(this.item.password)) this.errors.push("Содержать минимум одну цифру.");
                if (!/[A-Z]/.test(this.item.password)) this.errors.push("Содержать минимум 1 заглавную букву.");
                if (this.item.password !== this.item.password_confirmation) this.errors.push("Пароли не совпадают.");
            },

            onSubmit(e){
                this.checkForm(e)
                if (this.errors.length === 0){
                    this.axios
                        .post(this.axios.defaults.baseURL + 'register', this.item)
                        .then(response => {
                            if (response.data.message === 'success') {
                                this.$router.push({name: 'AdminManagers', params: {message: 'Менеджер успешно создан'}})
                            }else {
                                this.errors = response.data.errors
                            }
                        })
                        .catch(error => {
                            console.log(error);
                        })
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .image-cart {
        width: 100%;
        height: 200px;
        object-fit: contain;
        object-position: center;
    }

    .buttons {
        margin: 25px 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/app/admin/managers/register.vue